import { createTestIds } from '../../utils';

export const getBackdropTestIds = createTestIds('backdrop', [] as const);
